<template lang="">
  <div class="chart-box">
    <div ref="chart" class="chart"></div>
  </div>
</template>

<script>
import { loadChart } from "../charts/lzczData";
import { get } from "@/api/index";
import { findIndexByName } from "@/util/index";
export default {
  data() {
    return {
      //   typeList: ["2017年", "2018年", "2019年", "2020年", "2021年"],
      //   active: 0
    };
  },
  mounted() {
    this.chart = this.$echarts.init(this.$refs.chart);
    this.getData();
  },
  methods: {
    // changeType(index, name) {
    //   this.active = index;
    //   this.selectName = name;
    //   this.getData();
    // },
    getData() {
      get("/api/restful/cyzl/getMMLZPriceTrend").then((res) => {
        const data = res.data;
        console.log("data111---", data);
        let typeList = [];
        // let bfData = [];
        let firstYear = "";
        // 求并集，并排序
        let _data = [];
        for (let key in data) {
          if (!firstYear) {
            firstYear = key;
          }
          typeList.push(key + "年");
          _data.push({
            year: key,
            data: data[key].map((e) => {
              e.date = e.date.replace(/^\d{4}-/, "");
              e.dates = e.date.replace(/^\d{4}-|-/g, "");
              return e;
            }),
          });

          // tip:无用
          // bfData.push(
          //   data[key].map(e => {
          //     return e.price;
          //   })
          // );
        }
        // console.log("_data", _data);
        // 并集数据
        var xdata = _data.reduce((pre, cur) => {
          // console.log(i, pre, cur);
          return pre.concat(
            cur.data.map((e) => e.dates).filter((v) => !pre.includes(v))
          );
        }, []);
        // 修改成升序
        xdata.sort();
        let _bfData = [];
        let _lastLen = 1;
        const _datalen = _data.length - 1;
        _data.forEach((e, i) => {
          if (i === _datalen) {
            const _index0 = xdata.findIndex((v) => {
              return v === e.data.slice(-1)[0]["dates"];
            });
            _lastLen = _index0 > 0 ? _index0 : 1;
          }
          const _arr = [];
          const _data = e.data;
          xdata.map((e1) => {
            const _index = findIndexByName(e1, _data, "dates");
            if (~_index) {
              _arr.push(_data[_index]["price"]);
            } else {
              _arr.push(null);
            }
          });
          _bfData.push(_arr);
        });
        loadChart(
          this.chart,
          typeList,
          xdata.map((e) => e.replace(/(\d{2})(\d{2})/, "$1-$2")), // 处理成 05-22
          _bfData,
          "元/公斤",
          "备注：全国市场零售平均价",
          _lastLen
        );
      });
      //   get("/api/restful/cyzl/getPriceTrend").then(res => {
      //     let data = res.data;
      //     let year_17 = [];
      //     let year_18 = [];
      //     let year_19 = [];
      //     let year_20 = [];
      //     let year_21 = [];
      //     data.theFirstFourYears.map(it => {
      //       year_17.push(it.num);
      //     });
      //     data.theFirstThreeYears.map(e => {
      //       year_18.push(e.num);
      //     });
      //     data.twoYearsBefore.map(e2 => {
      //       year_19.push(e2.num);
      //     });
      //     data.theYearBeforeLasts.map(e3 => {
      //       year_20.push(e3.num);
      //     });
      //     data.thisYears.map(e4 => {
      //       year_21.push(e4.num);
      //     });
      //     this.chart = this.$echarts.init(this.$refs.chart);
      //     const yearlist = [
      //       "1",
      //       "2",
      //       "3",
      //       "4",
      //       "5",
      //       "6",
      //       "7",
      //       "8",
      //       "9",
      //       "10",
      //       "11",
      //       "12"
      //     ];

      //     const resultArr = this.typeList;
      //     const bfData = [year_17, year_18, year_19, year_20, year_21];
      //     const unit = "元";
      //     loadChart(this.chart, resultArr, yearlist, bfData, unit);
      //   });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'

.flex
  display flex
  justify-content center

.chart-box
  width 100%
  height 100%
  position relative

  .tab-box
    position absolute
    top 15px
    right 4%
    z-index 999

    .tab-item
      color #fff
      font-size 10px
      padding-left 13px
      margin-right 20px
      position relative
      cursor pointer

      &:before
        content ' '
        // width 6px
        // height 6px
        width 12px
        height 12px
        border-radius 50%
        background #fff
        position absolute
        left 0
        top 50%
        transform translateY(-50%)

    .active
      color #0e9cff

      &:before
        background #0e9cff
</style>
